import { render } from "./GenericSubmissionStatus.vue?vue&type=template&id=2c14a981&ts=true"
import script from "./GenericSubmissionStatus.vue?vue&type=script&lang=ts"
export * from "./GenericSubmissionStatus.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__